import React from 'react'
import {BsGithub} from 'react-icons/bs'
import {SiLeetcode, SiGeeksforgeeks, SiCodingninjas } from 'react-icons/si'
import { TiSocialLinkedin } from "react-icons/ti";


const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
          <a href="https://github.com/Aayushraj22" target='_blank' rel='noreferrer'>
            <BsGithub/>
          </a>
        </div>
        <div>
          <a href="https://leetcode.com/Ayush_Raj_22/" target='_blank' rel='noreferrer'>
            <SiLeetcode/>
          </a>
        </div>
        <div>
          <a href="https://auth.geeksforgeeks.org/user/ay_raj/practice" target='_blank' rel='noreferrer'>
            <SiGeeksforgeeks/>
          </a>
        </div>
        <div>
          <a href="https://www.naukri.com/code360/profile/ayush_raj2" target='_blank' rel='noreferrer'>
            <SiCodingninjas/>
          </a>
        </div>
        <div>
          <a href="https://www.linkedin.com/in/ayush-r-5760b61a1/" target='_blank' rel='noreferrer'>
            <TiSocialLinkedin/>
          </a>
        </div>
    </div>
  )
}

export default SocialMedia